<div class="columns-modal--content">
  <op-draggable-autocompleter [options]="availableColumnsOptions"
                              [selected]="selectedColumns"
                              [inputLabel]="text.inputLabel"
                              [inputPlaceholder]="text.inputPlaceholder"
                              [dragAreaLabel]="text.inputDragLabel"
                              [id]="'columns-select'"
                              (onChange)="updateSelected($event)">
  </op-draggable-autocompleter>
</div>

<op-enterprise-banner-frame
  feature="work_package_query_relation_columns"
  [dismissable]="true"
></op-enterprise-banner-frame>
